import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ResponsiveContext, Button, Layer, TextInput, Box, Select, Anchor } from 'grommet';
import { FormClose } from 'grommet-icons';

import { TitleField } from '../../../../components/form';
import { Hr, TitleDetail } from '../../../../components/detail';

import { searchManifestations, clearFieldsFormSearch, hideLayer, setDefaultPageRules } from '../../actions/form-search';
import { changeValues } from '../../../../actions/form';

import paginationDefault from '../../../../constants/pagination';
import visibleWidth from '../../../../constants/layer-width';

import selectManifestationStatusOptions from '../../../../constants/select-manifestation-status';

import TYPES from '../../actions/types';

class FormSearch extends Component {
  searchAndSetPagination = formParams => {
    const { searchManifestations, hideLayer, setDefaultPageRules } = this.props;

    setDefaultPageRules();
    searchManifestations(formParams);
    hideLayer();
  };

  render() {
    const {
      protocolNumber,
      name,
      email,
      telephone,
      statusId,
      toggleLayer,

      hideLayer,
      clearFieldsFormSearch,
      changeValues,
    } = this.props;

    if(toggleLayer && toggleLayer === 'search') {
      return (
        <ResponsiveContext.Consumer>
          {size => (
            <Layer
              responsive={false}
              full='vertical'
              position='left'
              onClickOutside={hideLayer}
              onEsc={hideLayer}
            >
              <Box
                fill='vertical'
                width={visibleWidth[size]}
                pad={{ top: 'large', bottom: 'xsmall' }}
                overflow='auto'
                flex
              >
                <Box
                  direction='row'
                  justify='between'
                  align='baseline'
                  margin={{ horizontal: 'large' }}
                >
                  <TitleDetail value='Filtrar' />

                  <Button
                    plain
                    title='Fechar'
                    icon={<FormClose />}
                    onClick={hideLayer}
                  />
                </Box>


                <Box flex overflow='auto'>
                  {/* Protocolo */}
                  <Box
                    margin={{
                      vertical: size === 'small' ? 'medium' : 'small',
                      horizontal: 'large'
                    }}
                    flex={{ shrink: 0 }}
                  >
                    <TitleField text='Número protocolo' />

                    <TextInput
                      value={protocolNumber ?? ''}
                      onChange={event =>
                        changeValues(
                          { fieldName: 'protocolNumber', value: event.target.value }, TYPES.changeFormSearchField
                        )
                      }
                    />
                  </Box>

                  <Hr />

                  <Box
                    margin={{
                      vertical: size === 'small' ? 'medium' : 'small',
                      horizontal: 'large'
                    }}
                    flex={{ shrink: 0 }}
                  >
                    <Box direction='row' align='center' gap='xsmall'>
                      <TitleField text='Status' />

                      {statusId && (
                        <Anchor
                          size='small'
                          label='limpar'
                          onClick={() =>
                            changeValues({ fieldName: 'statusId', value: null }, TYPES.changeFormSearchField)
                          }
                        />
                      )}
                    </Box>

                    <Select
                      options={selectManifestationStatusOptions}
                      value={statusId ?? ''}
                      labelKey='name'
                      valueKey={{ key: 'id', reduce: true }}
                      onChange={({ value: nextValue }) =>
                        changeValues({ fieldName: 'statusId', value: nextValue }, TYPES.changeFormSearchField)
                      }
                    />
                  </Box>


                  <Hr />

                  {/* Nome */}
                  <Box
                    margin={{
                      vertical: size === 'small' ? 'medium' : 'small',
                      horizontal: 'large'
                    }}
                    flex={{ shrink: 0 }}
                  >
                    <TitleField text='Nome' />

                    <TextInput
                      value={name ?? ''}
                      onChange={event =>
                        changeValues(
                          { fieldName: 'name', value: event.target.value }, TYPES.changeFormSearchField
                        )
                      }
                    />
                  </Box>

                  {/* Email/telefone */}
                  <Box
                    margin={{
                      vertical: size === 'small' ? 'medium' : 'small',
                      horizontal: 'large'
                    }}
                    flex={{ shrink: 0 }}
                  >
                    <Box
                      direction='row'
                      gap='small'
                    >
                      <Box width='large'>
                        <TitleField text='E-mail' />

                        <TextInput
                          value={email ?? ''}
                          onChange={event =>
                            changeValues({ fieldName: 'email', value: event.target.value }, TYPES.changeFormSearchField)
                          }
                        />
                      </Box>

                      <Box width='large'>
                        <TitleField text='Telefone' />

                        <TextInput
                          value={telephone ?? ''}
                          onChange={event =>
                            changeValues({ fieldName: 'telephone', value: event.target.value }, TYPES.changeFormSearchField)
                          }
                        />
                      </Box>
                    </Box>
                  </Box>
                </Box>

                <Box
                  direction='row'
                  pad={{ vertical: 'medium' }}
                  margin={{ horizontal: 'large' }}
                  justify='center'
                  align='center'
                  gap='small'
                >
                  <Box width='small'>
                    <Button
                      color='dark-3'
                      label='Limpar'
                      onClick={() => clearFieldsFormSearch()}
                    />
                  </Box>

                  <Box width='small'>
                    <Button
                      color='brand'
                      primary
                      label='Buscar'
                      onClick={() =>
                        this.searchAndSetPagination({
                          protocolNumber,
                          name,
                          email,
                          telephone,
                          statusId,
                          page: paginationDefault.page,
                          limit: paginationDefault.limit,
                        })
                      }
                    />
                  </Box>
                </Box>
              </Box>
            </Layer>
          )}
        </ResponsiveContext.Consumer>
      )
    }

    return null;
  }
}

const mapStateToProps = ({ manifestationReducer: { formSearch }, layerReducer }) => ({
  protocolNumber: formSearch.protocolNumber,
  name: formSearch.name,
  email: formSearch.email,
  telephone: formSearch.telephone,
  statusId: formSearch.statusId,

  toggleLayer: layerReducer.toggleLayer,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    searchManifestations,
    clearFieldsFormSearch,
    setDefaultPageRules,
    hideLayer,
    changeValues,
  }, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(FormSearch);
